export default __webpack_public_path__ + "static/media/sky.074d1d89.png";